import { TFunction } from "react-i18next";
import {
	PaymentMethodIntegration,
	PaymentMethodSetting,
	PaymentMethodSettingApi,
} from "../../../../../../../../../services/Api/Organization/types";

export const getIntegrationName = (integration: PaymentMethodIntegration, t: TFunction) => {
	switch (integration) {
		case PaymentMethodIntegration.TPAY:
			return t("enums.payment_methods.integrations.TPAY");
		default:
			return "";
	}
};

export const findPaymentMethodSettingIndexForInput = (
	settings: PaymentMethodSettingApi[],
	inputSetting: PaymentMethodSetting
) => {
	return settings.findIndex((setting) => setting.name === inputSetting);
};

export const isPaymentMethodIntegrationInstalled = (
	integration: PaymentMethodIntegration,
	settings: PaymentMethodSettingApi[]
) => {
	switch (integration) {
		case PaymentMethodIntegration.TPAY: {
			return getPaymentMethodSecretClientId(settings) && getPaymentMethodClientSecret(settings);
		}
		default:
			return false;
	}
};

export const getPaymentMethodSecretClientId = (settings: PaymentMethodSettingApi[]) =>
	settings.find((setting) => setting.name === PaymentMethodSetting.SECRET_TPAY_CLIENT_ID);

export const getPaymentMethodClientSecret = (settings: PaymentMethodSettingApi[]) =>
	settings.find((setting) => setting.name === PaymentMethodSetting.SECRET_TPAY_CLIENT_SECRET);
